import { render } from "./AddEditDmccComponent.vue?vue&type=template&id=66a36779"
import script from "./AddEditDmccComponent.vue?vue&type=script&lang=js"
export * from "./AddEditDmccComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__